import React from 'react'

export default function Nextpage() {
  return (
    <div className='second'>
      <div className='first-title'> 
      <h1 className="n">PLAY TO EARN</h1>
      <p className='o'>INCOME OPPORTUNITIES POWERED BY NEXT-GENERATION GAMES</p>
      <p className='oo'>To earn income Scholars must use NFTs to complete in-game tasks. <br />
       By playing the game and completing the task they  earn cryptocurrency <br />
      which can then be exchanged for local fiat currency.We partner with by <br />
       providing them them the NFTs required to play the game. We then share the profits from their earnings.</p> <br /> <br />
       <button className='btn'>ARCADE</button> 
      </div>
      <img style={{width: '350px', position: 'relative', height: '380px'}}  className=""src={require('/Users/macbook/metawork/src/assets/Group 4.png')} /> <br />
      
    </div>
  )
}
